import { useSelector } from "react-redux";
import { LayoutProps } from "./props";
import { RootReducer } from '@/store/reducers/reducer'

export default (): LayoutProps => {
  return {
    idToken: useSelector<RootReducer, string | null>(({ idToken }) => idToken)
  };
};
